import { Info, X } from "lucide-react";
import Button from "../Button";
import "./_banner.scss";

/**
 * Moved from components/common/Banner. `buttonConfig` mirrors the old prop
 * shape ({variant, text, onClick, disabled}) - destructured explicitly
 * rather than spread, since spreading `text` onto the in-house Button would
 * leak it as an invalid DOM attribute on the native <button>.
 */
const Banner = ({ message, type = "info", icon: Icon = Info, className = "", buttonConfig, onClose, ...props }) => {
  const bannerClass = ["banner", `banner--${type}`, className].filter(Boolean).join(" ");

  return (
    <div className={bannerClass} {...props}>
      {onClose && <X size={12} onClick={onClose} className="banner__close" />}
      <div className="banner__main-content">
        <div className="banner__icon">
          <Icon size={16} />
        </div>
        <div className="banner__content">
          <p className="banner__message">{message}</p>
        </div>
      </div>
      {buttonConfig && (
        <div className="banner__action-buttons">
          <Button variant={buttonConfig.variant} size="sm" onClick={buttonConfig.onClick} disabled={buttonConfig.disabled}>
            {buttonConfig.text}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Banner;
